// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fQQdflQzJru7HurRs6vS {
  display: flex;
  align-items: center;
  column-gap: 0.75rem;
  width: fit-content;
}
.fQQdflQzJru7HurRs6vS .M6txTdTE24JfRPw8XlUF {
  display: flex;
  font-size: 1rem;
  line-height: 1.1875rem;
  font-weight: 400;
  color: #fff;
  transition: all 0.3s;
}
.fQQdflQzJru7HurRs6vS .T2j8KKUns_jD_FXJyfdT {
  transition: all 0.3s;
  color: #474747;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .Ml5RZhV2EUhItwwP0Zzb {
  position: relative;
  display: flex;
  width: 100%;
  height: 20px;
  border: 1px solid #dbdbdb;
  border-radius: 10px;
  box-sizing: border-box;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .Ml5RZhV2EUhItwwP0Zzb .R5OKVU2iGwyq5pRgCYFx {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  display: flex;
  width: 13.33px;
  height: 13.33px;
  border-radius: 50%;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .Ml5RZhV2EUhItwwP0Zzb:hover {
  cursor: pointer;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .BPV15PuPRd41XYNFwEIX {
  background-color: #dbdbdb;
  transition: all 0.3s;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .BPV15PuPRd41XYNFwEIX .R5OKVU2iGwyq5pRgCYFx {
  transform: translateX(22.33px);
  transition: all 0.3s;
  background-color: #8941ff;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .BPV15PuPRd41XYNFwEIX:hover {
  transition: all 0.3s;
  background-color: #fff;
  border-color: #fff;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .BPV15PuPRd41XYNFwEIX:active {
  transition: all 0.3s;
  background-color: rgba(0, 0, 0, 0.1254901961);
  border-color: rgba(0, 0, 0, 0.1254901961);
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .UHOZAgiqLf23bZHD2WoQ {
  background-color: transparent;
  transition: all 0.3s;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .UHOZAgiqLf23bZHD2WoQ .R5OKVU2iGwyq5pRgCYFx {
  transform: translateX(3.33px);
  transition: all 0.3s;
  background-color: #dbdbdb;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .UHOZAgiqLf23bZHD2WoQ:hover {
  transition: all 0.3s;
  border-color: #fff;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .UHOZAgiqLf23bZHD2WoQ:hover .R5OKVU2iGwyq5pRgCYFx {
  transition: all 0.3s;
  background-color: #fff;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .UHOZAgiqLf23bZHD2WoQ:active {
  transition: all 0.3s;
  border-color: rgba(0, 0, 0, 0.1254901961);
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .UHOZAgiqLf23bZHD2WoQ:active .R5OKVU2iGwyq5pRgCYFx {
  transition: all 0.3s;
  background-color: rgba(0, 0, 0, 0.1254901961);
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:hover,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:active {
  transition: all 0.3s;
  background-color: #474747;
  border-color: #474747;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke .R5OKVU2iGwyq5pRgCYFx,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:hover .R5OKVU2iGwyq5pRgCYFx,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:active .R5OKVU2iGwyq5pRgCYFx {
  transition: all 0.3s;
  background-color: #2e2e2e;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:hover,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:hover:hover,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yJl8Uy92WN1m73ohKzke:active:hover {
  cursor: not-allowed;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:hover,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:active {
  transition: all 0.3s;
  background-color: transparent;
  border-color: #474747;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc .R5OKVU2iGwyq5pRgCYFx,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:hover .R5OKVU2iGwyq5pRgCYFx,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:active .R5OKVU2iGwyq5pRgCYFx {
  transition: all 0.3s;
  background-color: #474747;
}
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:hover,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:hover:hover,
.fQQdflQzJru7HurRs6vS .hPBrjW8v73fQANpvANLe .yKwTbTJDuHav7KHzrNuc:active:hover {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Toggle/Toggle.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,WCKI;EDJJ,oBAAA;AAAJ;AAGE;EACE,oBAAA;EACA,cCmBO;ADpBX;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAFJ;AAII;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAFN;AAIM;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAFR;AAKM;EACE,eAAA;AAHR;AAOI;EACE,yBCjCU;EDkCV,oBAAA;AALN;AAOM;EACE,8BAAA;EACA,oBAAA;EACA,yBChDS;AD2CjB;AAQM;EACE,oBAAA;EACA,sBCnDA;EDoDA,kBCpDA;AD8CR;AASM;EACE,oBAAA;EACA,6CAAA;EACA,yCAAA;AAPR;AAWI;EACE,6BAAA;EACA,oBAAA;AATN;AAWM;EACE,6BAAA;EACA,oBAAA;EACA,yBC9DQ;ADqDhB;AAYM;EACE,oBAAA;EACA,kBC1EA;ADgER;AAYQ;EACE,oBAAA;EACA,sBC9EF;ADoER;AAcM;EACE,oBAAA;EACA,yCAAA;AAZR;AAcQ;EACE,oBAAA;EACA,6CAAA;AAZV;AAiBI;;;EAGE,oBAAA;EACA,yBC7EK;ED8EL,qBC9EK;AD+DX;AAiBM;;;EACE,oBAAA;EACA,yBCvEI;AD0DZ;AAgBM;;;EACE,mBAAA;AAZR;AAgBI;;;EAGE,oBAAA;EACA,6BAAA;EACA,qBC/FK;ADiFX;AAgBM;;;EACE,oBAAA;EACA,yBCnGG;ADuFX;AAeM;;;EACE,mBAAA;AAXR","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `fQQdflQzJru7HurRs6vS`,
	"label": `M6txTdTE24JfRPw8XlUF`,
	"disabledLabel": `T2j8KKUns_jD_FXJyfdT`,
	"toggleContainer": `hPBrjW8v73fQANpvANLe`,
	"toggle": `Ml5RZhV2EUhItwwP0Zzb`,
	"switcher": `R5OKVU2iGwyq5pRgCYFx`,
	"activeToggle": `BPV15PuPRd41XYNFwEIX`,
	"inactiveToggle": `UHOZAgiqLf23bZHD2WoQ`,
	"disabledActiveToggle": `yJl8Uy92WN1m73ohKzke`,
	"disabledInactiveToggle": `yKwTbTJDuHav7KHzrNuc`
};
export default ___CSS_LOADER_EXPORT___;
